<template>
		<v-text-field
      v-model="setPasswordConfirmation"
      :rules="[rules.required, rules.passwordMin]"
      label="確認用パスワード(必須)"
      type="password"
      hint="英大文字・小文字・数字を含む8文字以上で入力して下さい"
      counter
			class="mt-4"
			outlined
			dense
		/>
</template>

<script>
import rules from "../../../helper/rules"

export default {
  props: {
    passwordConfirmation: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      rules: rules,
    }
  },
  computed: {
    setPasswordConfirmation: {
      get() {
        return this.passwordConfirmation
      },
      set(newValue) {
        return this.$emit("update:passwordConfirmation", newValue)
      },
    },
  },
}
</script>
